<template>
    <q-page class="q-pa-md">
        <q-dialog class="rounded-borders" v-model="dialogContrato" persistent>
            <q-card style="width: 1200px; max-width: 80vw;" class="shadow-0">
                <q-card-section class="row items-center q-pb-none">
                    <div class="text-h6">Contrato Anterior</div>
                    <q-space />
                    <q-btn icon="close" flat round dense v-close-popup />
                </q-card-section>
                <q-card-section>
                    <q-card class="shadow-0" v-if="nuevoContratoAnterior">
                        <q-card-section>
                            <div class="row q-col-gutter-sm">
                                <div class="col-12">
                                    <q-select outlined v-model="selectCliente" :options="clientes" label="Cliente"
                                        option-label="rfc" option-value="_id_cliente" dense required emit-value
                                        map-options>
                                        <template v-slot:option="scope">
                                            <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                                                <q-item-section avatar>
                                                    <q-icon name="mdi-account" color="priamry" />
                                                </q-item-section>
                                                <q-item-section>
                                                    <q-item-label
                                                        v-html="scope.opt.rfc + ' ' + scope.opt.razon_social" />
                                                </q-item-section>
                                            </q-item>
                                        </template>
                                    </q-select>
                                </div>
                                <div class="col-12 col-md-12">
                                    <q-select outlined v-model="auto" :options="listaCarros" label="Automovil"
                                        option-label="placa" option-value="_id" dense required emit-value map-options>
                                        <template v-slot:option="scope">
                                            <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                                                <q-item-section avatar>
                                                    <q-icon name="mdi-car" color="priamry" />
                                                </q-item-section>
                                                <q-item-section>
                                                    <q-item-label
                                                        v-html="scope.opt.placa + ' ' + scope.opt.estadoplaca + ' ' + scope.opt.numeroserie" />
                                                </q-item-section>
                                            </q-item>
                                        </template>
                                    </q-select>
                                </div>
                                <div class="col-12 col-md-12">
                                    <q-input dense v-model="nuevoContratoAnterior.nregistro" outlined
                                        label="No. Registro" required />
                                </div>
                                <div class="col-12 col-md-4">
                                    <q-select v-model="nuevoContratoAnterior.plazos" dense outlined label="Plazos"
                                        :options="itemsPlazos" option-label="label" option-value="value" emit-value
                                        map-options class="full-width">
                                    </q-select>
                                </div>
                                <div class="col-12 col-md-4">
                                    <q-input prefix="$" dense v-model="montotoralvehiculo" outlined
                                        label="Monto total del Vehiculo" required mask="#.##" fill-mask="0"
                                        reverse-fill-mask input-class="text-right" />
                                </div>
                                <div class="col-12 col-md-4">
                                    <q-input prefix="$" dense v-model="mensualidad" outlined label="Mensualidad"
                                        required mask="#.##" fill-mask="0" reverse-fill-mask input-class="text-right" />
                                </div>
                                <div class="col-12 col-md-4">
                                    <q-input prefix="$" dense v-model="pagoresidual" outlined label="Pago Residual"
                                        required mask="#.##" fill-mask="0" reverse-fill-mask input-class="text-right" />
                                </div>
                                <div class="col-12 col-md-4">
                                    <q-select v-model="nuevoContratoAnterior.mensualidades" outlined
                                        label="Mensualidades" dense required :options="mensualidades" />
                                </div>
                                <div class="col-12 col-md-4">
                                    <q-select v-model="nuevoContratoAnterior.mensualidadesrestantes" outlined
                                        label="Mensualidades Restantes" dense required :options="mensualidades" />
                                </div>
                                <div class="col-12 col-md-4">
                                    <q-input class="q-ma-none q-pa-none" dense outlined
                                        v-model="nuevoContratoAnterior.fechainiciocontrato"
                                        label="Fecha de Inicio de Contrato" mask="date" bottom-slots
                                        placeholder="yyyy/MM/dd">
                                        <template v-slot:append>
                                            <q-icon name="event" class="q-ma-none q-pa-none cursor-pointer">
                                            </q-icon>
                                        </template>
                                    </q-input>
                                </div>
                                <div class="col-12 col-md-4">
                                    <q-input class="q-ma-none q-pa-none" dense outlined
                                        v-model="nuevoContratoAnterior.fechapago" label="Fecha de Pago" mask="date"
                                        bottom-slots placeholder="yyyy/MM/dd">
                                        <template v-slot:append>
                                            <q-icon name="event" class="q-ma-none q-pa-none cursor-pointer">
                                            </q-icon>
                                        </template>
                                    </q-input>
                                </div>
                                <div class="col-12 col-md-4">
                                    <q-input class="q-ma-none q-pa-none" dense outlined
                                        v-model="nuevoContratoAnterior.fechafacturacion" label="Fecha de Facturación"
                                        mask="date" bottom-slots placeholder="yyyy/MM/dd">
                                        <template v-slot:append>
                                            <q-icon name="event" class="q-ma-none q-pa-none cursor-pointer">
                                            </q-icon>
                                        </template>
                                    </q-input>
                                </div>
                            </div>
                        </q-card-section>
                        <q-card-actions class="row justify-between">
                            <q-btn flat color="red" label="Cerrar" v-close-popup />
                            <q-btn flat color="primary" label="Crear Contrato" @click="PostContrato()" />
                        </q-card-actions>
                    </q-card>
                </q-card-section>
            </q-card>
        </q-dialog>

        <div class="row q-pt-md q-col-gutter-md">
            <div class="col-md-12 col-12'">
                <q-table dense title="Contratos Anteriores" class="shadow-1" :data="items" :loading="loading"
                    :columns="columns" color="primary" row-key="_id" :pagination="initialPagination">
                    <template v-slot:top-right>
                        <q-btn outline ref="" color="primary" icon="mdi-refresh" label="Consultar" no-caps
                            class="q-mr-sm q-my-md" />
                        <q-btn outline color="primary" icon="mdi-plus" label="Nuevo" class="q-my-md"
                            @click="nuevoItem()" />
                    </template>
                    <template v-slot:body="props">
                        <q-tr :props="props" class="hover-fila">
                            <q-td key="nregistro" :props="props" @click="verItem(props.row)">{{ props.row.nregistro
                                }}</q-td>
                            <q-td key="plazos" :props="props" @click="verItem(props.row)">{{ props.row.plazos }}</q-td>
                            <q-td key="montotoralvehiculo" :props="props" @click="verItem(props.row)">{{
                                formatoMonedaMexicana(props.row.montotoralvehiculo) }}</q-td>
                            <q-td key="mensualidad" :props="props" @click="verItem(formatearFecha(props.row))">{{
                                formatoMonedaMexicana(props.row.mensualidad) }}</q-td>
                            <q-td key="pagoresidual" :props="props" @click="verItem(props.row)">{{
                                formatoMonedaMexicana(props.row.pagoresidual) }}</q-td>
                            <q-td key="mensualidades" :props="props" @click="verItem(props.row)">{{
                                props.row.mensualidades
                                }}</q-td>
                            <q-td key="mensualidadesrestantes" :props="props" @click="verItem(props.row)">{{
                                props.row.mensualidadesrestantes
                                }}</q-td>
                            <q-td key="fechainiciocontrato" :props="props" @click="verItem(props.row)">{{
                                formatearFecha(props.row.fechainiciocontrato)
                                }}</q-td>
                            <q-td key="fechapago" :props="props" @click="verItem(props.row)">{{
                                formatearFecha(props.row.fechapago)
                                }}</q-td>
                            <q-td key="fechainiciocontrato" :props="props" @click="verItem(props.row)">{{
                                formatearFecha(props.row.fechainiciocontrato)
                                }}</q-td>
                            <q-td key="estado" :props="props" @click="verItem(props.row)">
                                <q-badge v-if="props.row.estado == 'activo'" color="green" label="Activo" />
                                <q-badge v-if="props.row.estado == 'inactivo'" color="organge" label="Inactivo" />
                            </q-td>
                        </q-tr>
                    </template>
                </q-table>
            </div>
        </div>
    </q-page>
</template>

<script>
import axios from "axios";
import { QSpinnerClock } from 'quasar'

export default {
    data() {
        return {

            loading: false,
            items: [],
            columns: [
                { name: 'nregistro', label: 'No. Registro', field: 'nregistro', align: 'center', sortable: true },
                { name: 'plazos', label: 'Plazos', field: 'plazos', align: 'center', sortable: true },
                { name: 'montotoralvehiculo', label: 'Monto Total Vehiculo', field: 'montotoralvehiculo', align: 'center', sortable: true },
                { name: 'mensualidad', label: 'Mensualidad', field: 'mensualidad', align: 'center', sortable: true },
                { name: 'pagoresidual', label: 'Pago Residual', field: 'pagoresidual', align: 'center', sortable: true },
                { name: 'mensualidades', label: 'Mensualidades', field: 'mensualidades', align: 'center', sortable: true },
                { name: 'mensualidadesrestantes', label: 'Mensualidades Restantes', field: 'mensualidadesrestantes', align: 'center', sortable: true },
                { name: 'fechainiciocontrato', label: 'Inicio del Contrato', field: 'fechainiciocontrato', align: 'center', sortable: true },
                { name: 'fechapago', label: 'Fecha de Pago', field: 'fechapago', align: 'center', sortable: true },
                { name: 'fechafacturacion', label: 'Fecha de Facturación', field: 'fechafacturacion', align: 'center', sortable: true }
            ],

            initialPagination: {
                sortBy: 'rfc',
                descending: false,
                page: 1,
                rowsPerPage: 10
            },
            dialogContrato: false,
            nuevoContratoAnterior: null,
            clientes: [],
            listaCarros: [],
            auto: '',
            selectCliente: '',
            mensualidades: Array.from({ length: 49 }, (_, i) => i),
            itemsPlazos: [
                { label: '12 Meses', value: '12' },
                { label: '24 Meses', value: '24' },
                { label: '36 Meses', value: '36' },
                { label: '48 Meses', value: '48' },
            ],
            mensualidad: 0,
            montotoralvehiculo: 0,
            pagoresidual: 0

        };
    },
    computed: {

    },
    created() {
        this.GetClientes();
    },
    methods: {
        async PostContrato() {
            this.nuevoContratoAnterior.id_cliente = this.selectCliente
            this.nuevoContratoAnterior.id_auto = this.auto
            this.nuevoContratoAnterior.mensualidad = parseFloat(
                Number(this.mensualidad).toFixed(2)
            );
            this.nuevoContratoAnterior.montotoralvehiculo = parseFloat(
                Number(this.montotoralvehiculo).toFixed(2)
            );
            this.nuevoContratoAnterior.pagoresidual = parseFloat(
                Number(this.pagoresidual).toFixed(2)
            );
            console.log(this.nuevoContratoAnterior)
            if (this.auto == '') {
                this.$q.notify({ type: 'warning', position: 'top-right', message: `Indique el auto que se le asignara al contrato.` });
                return
            }
            if (this.selectCliente == '') {
                this.$q.notify({ type: 'warning', position: 'top-right', message: `Indique el cliente del contrato.` });
                return
            }
            return

            try {
                this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Creando contrato. Espere...', messageColor: 'white' })

                const resp = await axios.post(`Contratos/CrearContratoPasado/`, this.nuevoContratoAnterior);
                console.log(resp)

                if (resp.data.edopet == "0") {
                    this.$q.notify({ type: 'positive', position: 'top-right', message: `Se creo correctamente el Contrato.` });
                    this.dialogContrato = false

                } else {
                    this.$q.notify({ type: 'negative', position: 'top-right', message: `Error al crear el contrato. Intentelo de nuevo...` });
                }
                this.$q.loading.hide()
            } catch (error) {
                this.$q.loading.hide()
                this.$q.notify({ type: 'negative', position: 'top-right', message: `Error al crear el seguro. Intentelo de nuevo...` });
                console.log(error)
            }
        },
        nuevoItem() {
            this.GetAutos();

            this.nuevoContratoAnterior = {
                id_cliente: '',
                id_auto: '',
                nregistro: '',
                plazos: '',
                montotoralvehiculo: 0,
                mensualidad: 0,
                pagoresidual: 0,
                mensualidades: '',
                mensualidadesrestantes: '',
                fechainiciocontrato: '',
                fechapago: '',
                fechafacturacion: '',
            }
            this.dialogContrato = true
        },
        async GetListaContratos() {
            // this.loading = true
            // try {
            //     let respuesa = await axios.get('Autos/GetListaSeguros/')
            //     console.log(respuesa)
            //     this.items = respuesa.data
            //     this.loading = false
            // } catch (error) {
            //     this.loading = false
            //     console.log(error)
            // }
        },
        async GetAutos() {
            try {
                let respuesa = await axios.get('Autos/GetAutosListaDisponibles/')
                console.log(respuesa.data)
                this.listaCarros = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },
        async GetClientes() {
            try {
                let respuesa = await axios.get('Configuracion/GetUsuariosDatosFiscales/')
                console.log(respuesa)
                this.clientes = respuesa.data
            } catch (error) {
                console.log(error)
            }
        },
        formatoMonedaMexicana(valor) {
            return valor.toLocaleString('es-MX', {
                style: 'currency',
                currency: 'MXN',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        },

        formatearFecha(isoString) {
            const fecha = new Date(isoString);

            const dia = String(fecha.getUTCDate()).padStart(2, '0');
            const mes = String(fecha.getUTCMonth() + 1).padStart(2, '0');
            const anio = fecha.getUTCFullYear();

            const hora = String(fecha.getUTCHours()).padStart(2, '0');
            const minutos = String(fecha.getUTCMinutes()).padStart(2, '0');
            const segundos = String(fecha.getUTCSeconds()).padStart(2, '0');

            return `${dia}/${mes}/${anio} ${hora}:${minutos}:${segundos}`;
        },

    }
};
</script>
<style>
.hover-fila:hover td {
    cursor: pointer;
    background: #dcf6ff;
}

.q-table thead,
[dir] .q-table tr,
[dir] .q-table th {
    border-color: #0094ca !important;
}

.doc-note {
    background-color: #f0f4f8;
    /* Fondo claro */
    border-left: 4px solid #007BFF;
    /* Línea de color azul en el borde izquierdo */
    padding: 16px;
    margin: 16px 0;
    border-radius: 8px;
    color: #333;
    /* Color de texto */
    font-family: Arial, sans-serif;
}

.doc-note__title {
    margin: 0 0 8px 0;
    font-weight: bold;
    color: #007BFF;
    /* Mismo tono del borde para coherencia */
    font-size: 16px;
}

.doc-note p {
    margin: 0;
    font-size: 14px;
    line-height: 1.5;
}
</style>